import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentEnviarEvidencia from './ContentEnviarEvidencia';

const SolicitacaoFluxoEnviarEvidencia = () => {
  return (
    <>
      <HeaderApp />
      <ContentEnviarEvidencia />
      <Bottom />
    </>
  );
};

export default SolicitacaoFluxoEnviarEvidencia;
